function getTags() {
    return new Promise((res, rej) => {
        res(TAGS)
    })
}

const TAGS = [
    {
        id: 1,
        text: 'Science',
        foreClr: 'blue',
        bgClr: 'black'
    },
    {
        id: 2,
        text: 'Computer Science',
        foreClr: 'yellow',
        bgClr: 'lightblue'
    },
    {
        id: 3,
        text: 'Philosophy',
        foreClr: 'grey',
        bgClr: 'red'
    },
]


export default getTags
